import ContentLoader, { IContentLoaderProps } from 'react-content-loader'
import { useTheme } from '@/hooks/useTheme'

export const Skeleton = ({ children, ...rest }: IContentLoaderProps) => {
  const theme = useTheme()

  return (
    <ContentLoader
      backgroundColor={theme.colors.background.secondaryGray + '40'}
      foregroundColor={theme.colors.background.secondaryGray + '60'}
      {...rest}
    >
      {children}
    </ContentLoader>
  )
}
